import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  purchaseReceive : {
    items : [],
    date : null,
    notes : null,
    inventoryId :null,
    purchaseOrderId : null,
    receiveAll : false,
    sell_before : null,
  },
  inventory_limit : null,
  maximumItemPriceVariation:null,
  minimumItemPriceVariation : null,
  purchaseReceiveStatus : null,
  loading : false,
  inventory : null

});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
